
define('template!portalWaitingTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (orders.length > 0) { ;
__p += '\n<div class="waiting-card">\n  <div class="waiting-card__head">\n    <span class="waiting-card__title">\n      ' +
((__t = ( _.i18n('portalMessages.waiting.title', null, 'Suppliers waiting on an answer') )) == null ? '' : __t) +
'\n    </span>\n    <span class="pill pill--warn">' +
((__t = ( orders.length )) == null ? '' : __t) +
'</span>\n  </div>\n\n  <table class="orders-table">\n    <tbody>\n      ';
 _.each(orders, function (order) { ;
__p += '\n        <tr class="orders-row orders-row--link js-open" data-secid="' +
__e( order.secId ) +
'">\n          <td><span class="orders-row__code">' +
__e( order.supplierCode ) +
'</span></td>\n          <td><span class="orders-row__poi">' +
__e( order.purchaseOrderId ) +
'</span></td>\n          <td>\n            <span class="orders-row__code">' +
__e( order.productCode ) +
'</span>\n            <span class="orders-row__muted">' +
__e( order.productName ) +
'</span>\n          </td>\n          <td>' +
((__t = ( order.delivery || '—' )) == null ? '' : __t) +
'</td>\n          <td class="waiting-card__count">\n            <span class="pill pill--message">\n              ' +
((__t = ( order.unreadMessages )) == null ? '' : __t) +
'\n              ' +
((__t = ( order.unreadMessages === 1
                ? _.i18n('portalMessages.unreadOne', null, 'unread message')
                : _.i18n('portalMessages.unreadMany', null, 'unread messages') )) == null ? '' : __t) +
'\n            </span>\n          </td>\n        </tr>\n      ';
 }); ;
__p += '\n    </tbody>\n  </table>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

